module.controller('viewVirtualCardCtrl', ['$scope', '$q', 'Session', '$state', '$http', '$rootScope', 'baseURI', '$stateParams', 'accountService', 'CARDS', function ($scope, $q, Session, $state, $http, $rootScope, baseURI, $stateParams, accountService, CARDS) {
  var cardUrl = baseURI + 'card/number';
  var cvvUrl = baseURI + 'card/cvv';
  var profileUrl = baseURI + 'cardholder/profile' + '?Username=' + encodeURIComponent($stateParams.username);

  $scope.accounts = accountService.getAccounts() || [];
  $scope.alert = {
    alertShown: false,
    alertMessage: 'There was a problem retrieving some of your virtual card information. Please try again at a later time.',
  };

  $scope.toggledFlipCard = false;
  $scope.copiedText = "-1";
  $scope.CardImageLink = '';
  $scope.fontColor = '#000';
  $scope.loading = true;
  $scope.designId = '';
  $scope.isDoneLoading = false;

  if($stateParams.username != Session.getUsername()){
    cardUrl += '?Username=' + $stateParams.username;
    cvvUrl += '?Username=' + $stateParams.username;
  }

  var checkIsDone = function() {
    $scope.isDoneLoading = !!($scope.cvv && $scope.cardNumber && $scope.address);
  };

  accountService.initializeAccounts(function(err, accounts){
    if(!err){
      $scope.accounts = accounts;
      $scope.account = accountService.getAccount($stateParams.username);

      if (!$scope.account.virtual) {
        return;
      }

      getProfile();
      getCVVNumber();
      getCardNumber();
      getCardData();
    }
  });

  $scope.isVirtualCard = function() {
    if (accountService.getAccount($stateParams.username).virtual === true) {
      $scope.account = accountService.getAccount($stateParams.username);
      return accountService.getAccount($stateParams.username).virtual;
    }
  };

  function getProfile(){
    $http.get(profileUrl, {cache: true}).then(function (resp){
      var data = resp.data;

      $scope.address = {
        Address: data.Data.Address1,
        AddressSuite: data.Data.Address2,
        City: data.Data.City,
        PostalCode: data.Data.PostalCode,
        State: data.Data.StateCode,
        Phone: data.Data.Phone,
        Email: data.Data.Email
      };

      if (data.Data.Address1.indexOf('3611 PAESANOS PKWY') != -1) {
        $scope.showDefaultAddress = true;
      }

      checkIsDone();
    }).catch(function(error){
      $scope.address = { };
      checkIsDone();
      console.log('err', error);
    });
  }

  $scope.copySuccess = function(e) {
    $scope.copiedText = e.text;
  };

  var displayError = function(){
    $scope.alert.alertShown = true;
  };

  //Get Card Number
  function getCardNumber() {
    $http.get(cardUrl, {cache: true}).then(function (resp){
      var data = resp.data;

      if(data.Success){
        $scope.cardNumber = data.Data.CardNumber;
        $scope.expDate = data.Data.ExpDate;

        checkIsDone();
      } else {
        $scope.cardNumber = ' ';
        $scope.expDate = ' ';
        checkIsDone();
        displayError();
      }
    }).catch(function (){
      $scope.cardNumber = ' ';
      $scope.expDate = ' ';
      checkIsDone();
      displayError();
    });
  }

  function getCVVNumber() {
    $http.get(cvvUrl, {cache: true}).then(function (resp) {
      var data = resp.data;

      if(data.Success){
        $scope.cvv = data.Data.CVV;

        checkIsDone();
      } else {
        $scope.cvv = ' ';
        checkIsDone();
        displayError();
      }
    }).catch(function (){
      $scope.cvv = ' ';
      checkIsDone();
      displayError();
    });
  }

  $scope.addCustomClass = function () {
    angular.element(document.querySelector("#cardAnimation")).addClass("flipCard");
  };

  $scope.flipCard = false;

  $scope.toggleFlipCard = function() {
    if($scope.flipCard === false){
      $scope.flipCard = true;
      angular.element(document.querySelectorAll("#flipCardAnimation")).addClass("flipCard");
    } else {
      $scope.flipCard = false;
      angular.element(document.querySelectorAll("#flipCardAnimation")).removeClass("flipCard");
    }
  };

  function getCardData(){
    if (!$scope.account) {
      return;
    }

    $scope.designId = $scope.account.designId;
    var cardStyle = CARDS[$scope.designId];

    if (!cardStyle) {
      cardStyle = 'dark';
    }

    if (cardStyle === 'dark') {
      $scope.fontColor = '#fff';
    }
  }
}]);


